@if (isVisible) {
  <div
    class="button-wrapper"
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    [ngClass]="{
      hoverable: dropdownItems && dropdownItems.length > 0,
      disabled: disabled || loading,
    }"
    (mouseenter)="disabled ? closeDropdown() : openDropdown()"
    (mouseleave)="scheduleDropdownClose()"
  >
    <a
      [routerLink]="
        !disabled
          ? routerConfig?.getFullPath
            ? routerConfig?.routeLink
            : getFullRoutePath(routerConfig?.routeLink)
          : null
      "
      [state]="routerConfig?.state"
      [queryParams]="routerConfig?.queryParams"
      (contextmenu)="handleContextMenu($event)"
    >
      <p-button
        [label]="label"
        [icon]="icon"
        [badge]="badge"
        [badgeClass]="badgeClassName"
        [text]="text"
        [rounded]="rounded"
        [severity]="severity"
        [size]="size"
        [loading]="loading"
        [loadingIcon]="loadingIcon"
        [disabled]="disabled || loading"
        [ngStyle]="styleObject"
        (onClick)="handleClick($event)"
        [styleClass]="getStyleClasses"
        [style]="{
          height: height,
          'min-width': minWidth,
        }"
        [iconPos]="iconPos"
        routerLink=""
      >
        <ng-template pTemplate="content">
          @if (src) {
            <img
              [src]="src"
              alt="icon"
              [width]="iconWidth"
              [height]="iconHeight"
            />
          }
          <span class="button-label">
            {{
              showLoaderLabel
                ? disabled || loading
                  ? (loadingLabel ?? "Loading...")
                  : label
                : label
            }}
          </span>
        </ng-template>
      </p-button>
    </a>
    @if (dropdownVisible && dropdownItems?.length > 0) {
      <ng-template
        cdkConnectedOverlay
        [cdkConnectedOverlayOrigin]="trigger"
        [cdkConnectedOverlayOpen]="dropdownVisible"
        [cdkConnectedOverlayHasBackdrop]="false"
        [cdkConnectedOverlayOffsetY]="4"
      >
        <div
          class="dropdown-menu"
          [ngClass]="{ 'dropdown-right': isLastItem, show: dropdownVisible }"
          (mouseenter)="disabled ? closeDropdown() : openDropdown()"
          (mouseleave)="scheduleDropdownClose()"
        >
          <ul>
            @for (item of dropdownItems; track $index) {
              <a
                class="router-Link"
                (click)="handleContextMenu($event, item)"
                [routerLink]="
                  !item?.errorMessage
                    ? item.getFullPath
                      ? item.routeLink
                      : (item.routeLink | fullPathBtnUrl: router.url)
                    : null
                "
                [state]="item?.state"
                [queryParams]="item?.queryParams"
                (contextmenu)="handleContextMenu($event, item)"
              >
                <li
                  [ngClass]="$index | buttonDropdownClass: item"
                  (mouseenter)="
                    disabled
                      ? toggleSubmenuDropdown(item.submenuList, false, $index)
                      : toggleSubmenuDropdown(item.submenuList, true, $index)
                  "
                  (mouseleave)="toggleSubmenuDropdown(item.submenuList, false)"
                  (click)="
                    !item.disabled && item.action && item.action();
                    toggleDropdown(false);
                    onDropdownItemClick.emit(item)
                  "
                >
                  <div [ngClass]="{ 'dropdown-image': item.src }">
                    @if (item?.src) {
                      <img [src]="item.src" />
                    }
                    <div
                      [ngClass]="{
                        'dropdown-label': item.src,
                      }"
                    >
                      {{ item.label | translate: translationCategory }}
                    </div>
                  </div>
                </li>
              </a>
            }
          </ul>
          @if (submenuDropdownVisible && subDropdownMenu?.length) {
            <div
              class="dropdown-menu submenu-dropdown"
              (mouseenter)="handleVisibilityState(true)"
              (mouseleave)="handleVisibilityState(false)"
              [ngStyle]="{
                left: submenuLeft,
                top: submenuTop,
                bottom: submenuBottom,
              }"
            >
              <ul>
                @for (item of subDropdownMenu; track $index) {
                  <a
                    class="router-Link"
                    [routerLink]="
                      !item?.errorMessage
                        ? item.getFullPath
                          ? item.routeLink
                          : (item.routeLink | fullPathBtnUrl: router.url)
                        : null
                    "
                    [state]="item?.state"
                    [queryParams]="item?.queryParams"
                    (contextmenu)="handleContextMenu($event, item)"
                    (click)="handleContextMenu($event, item)"
                  >
                    <li
                      (click)="
                        !item.disabled && item.action && item.action();
                        onDropdownItemClick.emit(item)
                      "
                    >
                      {{ item.label | translate: translationCategory }}
                    </li>
                  </a>
                }
              </ul>
            </div>
          }
        </div>
      </ng-template>
    }
  </div>
}
